(function () {
  'use strict';

  class CadastroDuoRoutesCtrl {
    constructor(Keys, ServiceVfiltro, FactoryVfiltro, safetyService, Authenticator, blockUI, $state) {
      this.keys = Keys;
      this.factoryVfiltro = FactoryVfiltro;
      this.serviceVfiltro = ServiceVfiltro;
      this.authenticator = Authenticator;
      this.safetyService = safetyService;
      this.blockUI = blockUI;
      this.state = $state;

      this.filtro = null;
      this.user = null;

      this.initialize();
    }

    initialize() {
      this.blockUI.start();
      return this.initFilter()
        .then(() => this.loadUser())
        .then(() => this.loadReact())
        .finally(() => {
          this.blockUI.reset();
          this.blockUI.stop();
        });
    }

    initFilter() {
      return this.serviceVfiltro.init(
        this.factoryVfiltro.get([
          {
            name: 'uoId',
            key: this.keys.uo.name
          }
        ])
      ).then((filtro) => {
        this.filtro = filtro;
      });
    }

    loadUser() {
      return this.authenticator.getUser()
        .then((user) => {
          this.user = user;
        });
    }

    loadReact() {
      const appName = 'safetyApp',
          componentName = './DuoRouteListPageRoute',
          componentId = 'safety-duo-route-list',
          props = this.getReactProps();

      return this.safetyService
        .initialize()
        .then(() => this.safetyService.loadReactComponent(appName, componentName, componentId, props));
    }

    goToRouteForm(duoRouteUUID) {
      this.state.go('root.duo-routes-cadastro.form', {
        duoRouteUUID: duoRouteUUID
      });
    }

    getReactProps() {
      return {
        user: this.user,
        filter: {
          ouId: this.filtro.find((f) => f.key === this.keys.uo.name).value.id
        },
        goToRouteForm: (duoRouteUUID) => this.goToRouteForm(duoRouteUUID)
      };
    }

  }

  angular
    .module('duo-routes.cadastro-rotas')
    .controller('CadastroDuoRoutesCtrl', CadastroDuoRoutesCtrl);
}());
